import React, {Component} from 'react';

class UploadImage2 extends Component {
    // Constructor de la clase UploadImage2 para cargar imágenes.
    constructor(props){
        super(props);
        this.state = {initialLoad: props.initialLoad, selectedImg: null};
    }

    // Limpia la imagen2 seleccionada.
    clearData = () => {
        this.setState({selectedImg: null, initialLoad: false});
        document.getElementById("uploadImage2Input").value = null;
    };

    // noinspection JSUnresolvedReference
    render = () => (
        <div>
            <label className="mt-3">Logo rectangular color</label>
            {(this.state.initialLoad || this.state.selectedImg) && (<div className="row justify-content-center">
                <div className="col-12 d-flex justify-content-center">
                    <img id="uploadImage2Img" className="load-img-bg-2" alt="Logo de organización" width={"350px"} onError={() => {this.clearData()}} src={(this.state.initialLoad ? this.props.strings.API_URL + "images/logo2/" + this.props.orgId + ".png" : URL.createObjectURL(this.state.selectedImg))} />
                </div>
                <div className="col-12 d-flex justify-content-center">
                    <button id="uploadImage2Clear" className="btn btn-danger my-3" onClick={() => this.clearData()}>
                        <i className="fas fa-trash" />
                    </button>
                </div>
            </div>)}
            <div className="row justify-content-center">
                <input id="uploadImage2Input" accept="image2/*" className="btn btn-primary" type="file" onChange={(event) => {
                    this.setState({selectedImg: event.target.files[0], initialLoad: false});
                }} />
            </div>
        </div>
    );
}

export default UploadImage2;